import { register } from '../apiRegistry';
import apiService from '../apiService';

// Faculty CaseCrumb mandatory/optional selection (Screen 3)
register({
  // Course scoping isn't instructor-specific on the backend yet (no
  // course_faculty ownership concept exists) -- any instructor can map any
  // course in the tenant for now. Reusing the full course list is the
  // documented, intentional stopgap; see the build plan's open item.
  'faculty/courses-list': async () => {
    return await apiService.get('course?status=active&limit=1000');
  },

  'faculty/casecrumbs-for-course': async (params) => {
    return await apiService.get(`faculty_casecrumb_selection/course/${params?.courseId}/available`);
  },

  'faculty/course-casecrumb-mappings': async (params) => {
    return await apiService.get(`faculty_casecrumb_selection/course/${params?.courseId}`);
  },

  'faculty/course-casecrumbs-save': async (params) => {
    return await apiService.post(`faculty_casecrumb_selection/course/${params?.courseId}/bulk`, {
      selections: params?.selections,
      replace: true,
    });
  },
});
